/**
 * «Entnahme aus der Rücklage» button at the end of the invoice section «4 Zahlungsanweisung».
 * Opens the Lux iframe modal and marks the button when a withdrawal was already booked.
 */
const RESERVE_WITHDRAWAL_WRAPPER_ID = 'lux-reserve-withdrawal'
const RESERVE_WITHDRAWAL_STATE_STYLES = {
  none: { background: '', color: '' },
  partial: { background: '#fff4d6', color: '#7a4e00' },
  full: { background: '#e5f6ea', color: '#146c2e' },
}
const RESERVE_WITHDRAWAL_ICONS = {
  none: '',
  partial:
    '<svg width="11" height="11" viewBox="0 0 16 16" style="margin-right:4px;vertical-align:-1px"><circle cx="8" cy="8" r="6.5" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M8 1.5a6.5 6.5 0 0 1 0 13z" fill="currentColor"/></svg>',
  full: '<svg width="11" height="11" viewBox="0 0 16 16" style="margin-right:4px;vertical-align:-1px"><circle cx="8" cy="8" r="7" fill="currentColor"/><path d="M4.5 8.2l2.2 2.2 4.8-4.8" fill="none" stroke="#fff" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
}

function reserveWithdrawalButton() {
  if (window.luxReserveWithdrawalObserver) return

  const tryInsert = () => {
    if (!/^\/invoice\/edit\/[A-Za-z0-9]+$/.test(window.location.pathname)) {
      return
    }
    const invoiceHrId = window.location.pathname.split('/').pop()
    const content = findPaymentInstructionContent()
    const existing = document.getElementById(RESERVE_WITHDRAWAL_WRAPPER_ID)
    if (
      existing &&
      existing.dataset.invoiceHrId === invoiceHrId &&
      content &&
      content.contains(existing)
    ) {
      placeAtSectionEnd(content, existing)
      return
    }
    if (existing) existing.remove()
    if (!content) return

    const wrapper = buildReserveWithdrawalWrapper(invoiceHrId)
    placeAtSectionEnd(content, wrapper)
    refreshReserveWithdrawalStatus(invoiceHrId)
  }

  let scheduled = false
  window.luxReserveWithdrawalObserver = new MutationObserver(() => {
    if (scheduled) return
    scheduled = true
    setTimeout(() => {
      scheduled = false
      tryInsert()
    }, 300)
  })
  window.luxReserveWithdrawalObserver.observe(document.body, {
    childList: true,
    subtree: true,
  })
  tryInsert()
}

// Impower removes the section content while «4 Zahlungsanweisung» is collapsed.
function findPaymentInstructionContent() {
  const byTestId = document.querySelector(
    '[data-testid="section-PaymentInstruction-content"]'
  )
  if (byTestId) return byTestId
  for (const section of document.querySelectorAll('.FormSection')) {
    const title = section.querySelector('.main-section-header .section-title')
    if (
      title &&
      /^Zahlungsanweisung$/i.test((title.textContent || '').trim())
    ) {
      return section.querySelector('.section-content')
    }
  }
  return null
}

// Last element of the section, above Impower's «Speichern und Weiter».
function placeAtSectionEnd(content, wrapper) {
  const submit = content.querySelector(':scope > .section-submit')
  if (submit) {
    if (wrapper.nextElementSibling !== submit) {
      content.insertBefore(wrapper, submit)
    }
  } else if (content.lastElementChild !== wrapper) {
    content.appendChild(wrapper)
  }
}

function buildReserveWithdrawalWrapper(invoiceHrId) {
  const wrapper = document.createElement('div')
  wrapper.id = RESERVE_WITHDRAWAL_WRAPPER_ID
  wrapper.dataset.invoiceHrId = invoiceHrId
  wrapper.style.cssText =
    'display:flex;justify-content:flex-start;margin:8px 0 16px 64px;'

  const button = document.createElement('button')
  button.type = 'button'
  button.className = 'ant-btn ant-btn-ghost Button'
  button.dataset.luxRole = 'reserve-withdrawal-button'
  button.style.cssText =
    'display:inline-flex;align-items:center;height:auto;padding:2px 8px;border:none;border-radius:4px;box-shadow:none;font-size:12px;font-weight:500;line-height:1.5;'
  button.addEventListener('click', (event) => {
    event.preventDefault()
    event.stopPropagation()
    openReserveWithdrawalModal(invoiceHrId)
  })
  wrapper.appendChild(button)
  renderReserveWithdrawalButton(button, { state: 'loading' })
  return wrapper
}

function formatReserveEuro(value) {
  return Number(value || 0).toLocaleString('de-DE', {
    style: 'currency',
    currency: 'EUR',
  })
}

function renderReserveWithdrawalButton(button, status) {
  const state =
    status && status.state in RESERVE_WITHDRAWAL_STATE_STYLES
      ? status.state
      : 'none'
  const styles = RESERVE_WITHDRAWAL_STATE_STYLES[state]
  button.style.background = styles.background
  button.style.color = styles.color
  button.dataset.luxState = status ? status.state : 'none'

  const amountLabel =
    status && status.withdrawnAmount
      ? ` (${formatReserveEuro(status.withdrawnAmount)})`
      : ''
  const positions = (status && status.positions) || []
  const positionCount = positions.length
  const bookedCount = positions.filter((position) => position.buchhalterisch)
    .length
  const paidCount = positions.filter((position) => position.monetaer).length
  let label = 'Entnahme aus der Rücklage'
  if (state === 'partial') {
    if (positionCount > 0) {
      label = `Entnahme teilweise (${Math.max(bookedCount, paidCount)}/${positionCount})${amountLabel}`
    } else {
      label = status.monetaer
        ? `Zahldatei erstellt${amountLabel}`
        : `Buchhalterisch entnommen${amountLabel}`
    }
  } else if (state === 'full') {
    label =
      positionCount > 0
        ? `Entnahme vollständig (${positionCount}/${positionCount})${amountLabel}`
        : `Entnahme gebucht + Zahldatei${amountLabel}`
  }
  const spinner =
    status && status.state === 'loading'
      ? '<span class="lux-reserve-spinner" style="width:9px;height:9px;margin-right:4px;border:1.5px solid #d9d9d9;border-top-color:#1677ff;border-radius:50%;display:inline-block;animation:luxReserveSpin 1s linear infinite"></span>'
      : ''
  button.innerHTML = `${spinner}${RESERVE_WITHDRAWAL_ICONS[state]}<span style="font-size:12px;line-height:1.5">${escapeHtml(label)}</span>`

  const entries = (status && status.entries) || []
  button.title = entries.length
    ? entries
        .map(
          (entry) =>
            `${new Date(entry.postDate).toLocaleDateString('de-DE')} · ${entry.reserveCode} · ${formatReserveEuro(entry.amount)}`
        )
        .join('\n')
    : ''

  if (!document.getElementById('lux-reserve-spin-style')) {
    const style = document.createElement('style')
    style.id = 'lux-reserve-spin-style'
    style.textContent =
      '@keyframes luxReserveSpin { to { transform: rotate(360deg); } }'
    document.head.appendChild(style)
  }
}

async function refreshReserveWithdrawalStatus(invoiceHrId) {
  const button = document.querySelector(
    `#${RESERVE_WITHDRAWAL_WRAPPER_ID}[data-invoice-hr-id="${invoiceHrId}"] button`
  )
  if (!button) return
  renderReserveWithdrawalButton(button, { state: 'loading' })
  try {
    const response = await fetch(
      `${baseApiUrl}/api/invoices/${encodeURIComponent(invoiceHrId)}/reserve-withdrawal/status`,
      { credentials: 'include', cache: 'no-store' }
    )
    if (!response.ok) throw new Error(`HTTP ${response.status}`)
    renderReserveWithdrawalButton(button, await response.json())
  } catch (error) {
    console.warn('Lux reserve withdrawal status failed', error)
    renderReserveWithdrawalButton(button, { state: 'none' })
  }
}

function openReserveWithdrawalModal(invoiceHrId) {
  if (document.getElementById('reserve-withdrawal-overlay')) return

  const overlay = document.createElement('div')
  overlay.id = 'reserve-withdrawal-overlay'
  overlay.style.cssText =
    'position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:10000;display:flex;justify-content:center;align-items:center;'

  const loading = document.createElement('div')
  loading.setAttribute('role', 'status')
  loading.style.cssText =
    'display:flex;flex-direction:column;align-items:center;gap:14px;background:#fff;padding:28px 36px;border-radius:10px;box-shadow:0 10px 30px rgba(0,0,0,0.18);font-family:inherit;font-size:14px;color:rgba(0,0,0,0.65);'
  loading.innerHTML =
    '<span style="width:32px;height:32px;border:3px solid rgba(0,0,0,0.08);border-top-color:#1677ff;border-radius:50%;display:inline-block;animation:luxReserveSpin 0.8s linear infinite"></span>' +
    '<span>Entnahme aus der Rücklage wird geladen…</span>'
  overlay.appendChild(loading)

  const iframe = document.createElement('iframe')
  iframe.src = `${baseApiUrl}/injects/reserve-withdrawal?invoiceHrId=${encodeURIComponent(invoiceHrId)}`
  iframe.style.cssText = 'width:100%;height:100%;border:none;display:none;'
  iframe.onload = () => {
    loading.remove()
    iframe.style.display = 'block'
    overlay.style.background = 'transparent'
  }
  overlay.appendChild(iframe)
  document.body.appendChild(overlay)

  const onMessage = (event) => {
    if (event.source !== iframe.contentWindow) return
    const type = event.data && event.data.type
    if (type === 'RESERVE_WITHDRAWAL_DONE') {
      refreshReserveWithdrawalStatus(invoiceHrId)
    } else if (type === 'CLOSE_RESERVE_WITHDRAWAL_MODAL') {
      window.removeEventListener('message', onMessage)
      overlay.remove()
    }
  }
  window.addEventListener('message', onMessage)
}
